<div *ngIf="loading$ | async" class="loading">
    <img class="stock-logo"  src="../../../../assets/img/logo-large.svg" />
    <div class="spinner">
        <div class="spinner__item1"></div>
        <div class="spinner__item2"></div>
        <div class="spinner__item3"></div>
        <div class="spinner__item4"></div>
    </div>
</div>
